import { DisplayMethod } from '@/types'

export interface BibliographyContentSearchTooliRequest {
  displayMethod: DisplayMethod
  searchMethodAnd: boolean
  title: string
  contentTitle: string
  contentTitleNot: boolean
  contentAuthor: string
  contentAuthorNot: boolean
}

export function BibliographyContentSearchTooliRequestToJSON(
  value: BibliographyContentSearchTooliRequest
): any {
  return {
    display_method: value.displayMethod || undefined,
    search_method_and: value.searchMethodAnd ?? undefined,
    title: value.title !== '' ? value.title : undefined,
    content_title: value.contentTitle !== '' ? value.contentTitle : undefined,
    content_title_not:
      value.contentTitle !== '' ? value.contentTitleNot : undefined,
    content_author:
      value.contentAuthor !== '' ? value.contentAuthor : undefined,
    content_author_not:
      value.contentAuthor !== '' ? value.contentAuthorNot : undefined
  }
}
